import React, { useState, useEffect, useRef } from "react";
import { API_BASE_URL } from "../../Config/Config";
import "./OTC.css";
import Swal from "sweetalert2";
import copy_image from "./../../Assets/Images/CreateBatch/copy_icon.png";
import SearchDropdown from "./OldDropdown";

const GenerateOTLC = () => {
  const [students, setStudents] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [otlc, setOtlc] = useState("");
  const otlcRef = useRef(null);
  const [isCopied, setIsCopied] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState({
    roll_number: "",
    student_full_name: "",
    status: "",
    class_type: "",
    course_name: "",
    batch_name: "",
    mobile_number: "",
  });

  useEffect(() => {
    const fetchStudents = async () => {
      if (searchKey.length >= 3) {
        const response = await fetch(
          `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-student-by-search-key/?search_key=${searchKey}`,
          {
            headers: {
              Accept: "application/json",
            },
          }
        );
        if (!response.ok) {
          console.error(`HTTP error! status: ${response.status}`);
        } else {
          const data = await response.json();
          setStudents(data);
        }
      }
    };

    fetchStudents();
  }, [searchKey]);

  const handleSelectStudent = (student) => {
    setSelectedStudent(student);
  };

  const handleInputChange = (inputValue) => {
    setSearchKey(inputValue);
  };

  const copyToClipboard = () => {
    if (otlc) {
      navigator.clipboard.writeText(otlc);
      setIsCopied(true); // show the span
      setTimeout(() => setIsCopied(false), 5000); // hide the span after 5 seconds
    }
  };
  const generateOtc = async () => {
    const response = await fetch(
      `${API_BASE_URL}/coaching-collaborator-api/api/v1/generate-student-otlc?roll_number=${selectedStudent.roll_number}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      console.error(`HTTP error! status: ${response.status}`);
    } else {
      const data = await response.json();
      setOtlc(data.otlc);
    }
  };

  const handleClearOTC = () => {
    Swal.fire({
      title: "Are you sure you want to cancel?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      confirmButtonColor: "rgb(100 101 101)",
      cancelButtonColor: "#318682",
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.reload();
      }
    });
  };

  return (
    <div className="container-otc">
      <div className="container-UP" style={{ position: "sticky", top: "0" }}>
        <div className="Header-up ">
          <p className="title-cb ">Generate One Time Login Code</p>
          <div className="mb-2-UP grey-color-font">
            <button className="cr-cancel-btn me-cs4" onClick={handleClearOTC}>
              CANCEL
            </button>
            {/* <button className="cr-create-btn">SAVE</button> */}
          </div>
        </div>
        <hr className="hr-otc" />
      </div>

      <div className="container-cs-fluid ms-cs3 mt-cs3">
        <div className="card-otc card-border-shadow-UR UR-form-size">
          <div className="header-otc">STUDENT DETAILS</div>
          <div className="student-select-otc">
            <SearchDropdown
              initialOptions={students}
              onSelect={handleSelectStudent}
              onInputChange={handleInputChange}
              className=""
              labelKey={(student) =>
                `${student.student_full_name} (${student.roll_number})`
              }
              dropdownStyle={{
                border: "1px solid #ccc",
                borderRadius: "4px",
                position: "absolute",
                zIndex: 1,
                width: "35%",
                boxShadow: "0px 8px 16px 0px rgba(0, 0, 0, 0.2)",
                overflow: "auto",
                maxHeight: "200px",
              }}
              inputStyle={{
                height: "30px",
                color: "#424342",
                width: "25%",
                marginTop: "5px",
                marginBottom: "5px",
                padding: "5px",
                outline: "none", // Add this line
              }}
              optionStyle={
                {
                  /* Your dropdown item styles here */
                }
              }
              optionClassName="dropdown-item-otc" // Your dropdown item class name here
              label="Select Student " // Your label here
            />
          </div>

          <hr className="hr" />

          <table className="otc-table">
            <tr>
              <td className="td-width-12-otc">Student Name :</td>
              <td className="td-width-20-otc">
                {selectedStudent.student_full_name}
              </td>
              <td className="td-width-12-otc"> Status :</td>
              <td>{selectedStudent.status}</td>
            </tr>
            <tr>
              <td className="td-width-12-otc"> Roll No :</td>
              <td className="td-width-30-otc">{selectedStudent.roll_number}</td>
              <td className="td-width-12-otc"> Phone No. :</td>
              <td>{selectedStudent.mobile_number}</td>
            </tr>
            <tr>
              <td className="td-width-12-otc">Class Type :</td>
              <td className="td-width-30-otc">{selectedStudent.class_type}</td>
              <td className="td-width-12-otc">Batch Name :</td>
              <td>{selectedStudent.batch_name}</td>
            </tr>
            <tr>
              <td className="td-width-12-otc">Course Name :</td>
              <td className="td-width-30-otc">{selectedStudent.course_name}</td>
            </tr>
          </table>

          <hr className="hr" />

          <div className="generate-code-otc">
            <div className="row-otc-v">
              <div className="col-otc-cs">
                <input
                  className="input-otc-2"
                  type="text"
                  disabled
                  value={otlc}
                  ref={otlcRef} // Add the ref to the input field
                />
                {otlc && ( // Only show the button when OTLC is generated
                  <button className="button-box-copy" onClick={copyToClipboard}>
                    <img src={copy_image} alt="" className="copy-otc" />
                  </button>
                )}
                {isCopied && ( // Only show the span when the copy button is clicked
                  <span className="copy-message">Copied successfully</span>
                )}
                <br />
                <button className="button-otc" onClick={generateOtc}>
                  Generate OTLC
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GenerateOTLC;
